<mat-list>
    <div mat-subheader>{{ listConfig.title }}</div>
    <mat-list-item *ngFor="let item of listConfig.items">
      <img class="icon" *ngIf="item.icon" src="/assets/images/icons/list/{{ item.icon }}" alt="{{ item.icon | titlecase }}"/>
      <div class="text" mat-line>{{ item.text }}</div>
      <div class="heading" mat-line *ngIf="item.caption"> {{ item.caption }} </div>
    </mat-list-item>
</mat-list>